<template>
    <section>
        <div v-if="show">

            <div>
                <b-modal :active="isModalCompositionByYearActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByYear modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByYearActive = false" />
                    </template>
                </b-modal>

                <b-modal :active="isModalCompositionByTypeActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByType modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByTypeActive = false" />
                    </template>
                </b-modal>
            </div>

            <b-collapse v-if="showTypes" :open="isOpenSummary" @open="isOpenSummary = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            Resumen de Patentes según su Estado
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <SummaryIndicatorPatents :indicator="summary" />
                    </div>
                </div>
            </b-collapse>

            <br v-if="showYears" >
            <b-collapse v-if="showYears" :open="isOpenYear" @open="isOpenYear = true" class="card" animation="slide"
                aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3"
                        :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 42 - Cantidad de Patentes por Año y Estado
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <IndicatorByYear :years="indicatorFing42"
                            :title="'patent_year'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByYearActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
            <br v-if="showTypes">
            <b-collapse v-if="showTypes" :open="isOpenType" @open="isOpenType = true" class="card" animation="slide"
                aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3"
                        :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 43 - Proporción de Patentes por Estado
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <IndicatorByType :types="indicatorFing43"
                            :title="'patent_type'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByTypeActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
        </div>
        <div v-else>
            <div class="columns is-centered">
                <div class="column is-6 is-centered has-text-centered">
                    <b-message has-icon type="is-warning">
                        <h1> No se encontraron resultados. Porfavor ingrese nuevas Patentes para mostrar sus
                            indicadores.</h1>
                    </b-message>
                </div>
            </div>
        </div>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />

    </section>
</template>

<script>
import axios from 'axios'
import IndicatorByType from './indicator_by_type.vue'
import IndicatorByYear from './indicator_by_year.vue'
import SummaryIndicatorPatents from './summary_indicator_patents.vue'
import ModalCompositionByYear from './modal_composition_by_year_patent.vue'
import ModalCompositionByType from './modal_composition_by_type_patent.vue'
export default {

    components: {
        IndicatorByType, IndicatorByYear, SummaryIndicatorPatents, ModalCompositionByYear, ModalCompositionByType,
    },

    props: [
        'minYear', 'maxYear', 'unitId', 'changeFilter', 'patentStates'
    ],

    data() {
        return {
            show: false,
            isOpenSummary: true,
            showType: true,
            isOpenYear: true,
            isOpenType: true,
            patentIndicator: {},
            isLoading: false,
            showYears: false,
            showTypes: false,

            //Modals
            canCancel: ["escape"],
            isModalCompositionByYearActive: false,
            isModalCompositionByTypeActive: false,

            //Indicadores
            summary: {
                total: 0,
                count_types: [],
            },
            indicatorFing42: {
                years: [],
                series: [],
            },
            indicatorFing43: [],
        }
    },

    async created() {
        this.show = false
        await this.getIndicatorFing42()
        await this.getIndicatorFing43()
        this.show = this.showYears || this.showTypes
    },

    methods: {

        async getIndicatorFing42() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing42',
                    }
                })
                .then(response => {
                    this.indicatorFing42 = {
                        years: [],
                        series: [],
                    }
                    this.showYears = false

                    this.indicatorFing42.years = [...new Set(response.data.map(indicator => indicator.year))].sort((a, b) => a - b)

                    for (let index = 0; index < this.patentStates.length; index++) {
                        let patentState = this.patentStates[index]
                        
                        let data = response.data.filter(indicator => indicator.type_id === patentState.id)
                                                .map(indicator => indicator.indicator_value)

                        this.indicatorFing42.series.push({
                            name: patentState.name,
                            data: data,
                        })

                        let suma = data.reduce((acumulador, valorActual) => acumulador + valorActual, 0);
                        this.showYears = this.showYears || (suma > 0)
                    }
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        async getIndicatorFing43() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing43',
                    }
                })
                .then(response => {
                    this.indicatorFing43 = []
                    this.summary = {
                        total: 0,
                        count_types: [],
                    }
                    this.showTypes = false

                    for (let index = 0; index < this.patentStates.length; index++) {
                        let patentState = this.patentStates[index]
                        
                        let value = response.data.filter(indicator => indicator.type_id === patentState.id)
                                                .map(indicator => indicator.indicator_value)
                                                .reduce((acumulador, valorActual) => acumulador + valorActual, 0)

                        this.indicatorFing43.push({
                            name: patentState.name,
                            value: value,
                        })

                        this.summary.total += value
                        this.summary.count_types = this.indicatorFing43
                        this.showTypes = this.showTypes || (value > 0)
                    }
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

    },

    watch: {
        async changeFilter() {
            this.show = false
            await this.getIndicatorFing42()
            await this.getIndicatorFing43()
            this.show = this.showYears || this.showTypes
            deep: true
        },
    },

}
</script>